<template>
  <v-chart
    v-if="options"
    v-click-outside.self="hideTooltip"
    class="chart"
    :options="options"
    @click="onClick"
    @datazoom="onDataZoom"
    @brushEnd="onBrushEnd"
    :ref="refName"
    autoresize
  />
</template>

<script>
import { mapGetters } from 'vuex'
import VueCharts from 'vue-echarts'

// import chart components
import 'echarts/lib/chart/pie'
import 'echarts/lib/chart/line'
import 'echarts/lib/chart/scatter'
import 'echarts/lib/component/dataZoom'
import 'echarts/lib/component/legend'
import 'echarts/lib/component/tooltip'
import 'echarts/lib/component/toolbox'
import 'echarts/lib/component/brush'
import 'echarts/lib/component/markPoint'
import 'echarts/lib/component/markLine'
import 'echarts/lib/component/markArea'

export default {
  name: 'bh-chart',
  props: {
    options: {
      type: Object
    },
    refName: {
      type: String,
      default: 'chart'
    },
    enableSyncZoom: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapGetters(['isNavBarClose'])
  },
  watch: {
    options: {
      handler() {
        this.hideTooltip()
      },
      deep: true
    },
    isNavBarClose() {
      this.$refs[this.refName]?.resize()
    }
  },
  mounted() {
    this.$root.$on('showToolTipChart', ({ chartName, options }) => {
      if (this.refName !== chartName) return
      const chart = this.$refs[this.refName]
      this.setTooltipVisibility(true)
      if (chart) {
        chart.dispatchAction(Object.assign({
          type: 'showTip',
          seriesIndex: 0,
          dataIndex: 0,
          position: 'top'
        }, options))
      }
    })

    this.$root.$on('hideToolTipChart', this.hideTooltip)

    // Resisze when window changes
    window.onresize = this.$refs[this.refName]?.resize
  },
  components: {
    'v-chart': VueCharts
  },
  methods: {
    onBrushEnd(e) {
      this.$emit('onBrushEnd', e)
    },
    onDataZoom(e) {
      if (!this.enableSyncZoom) return
      this.$emit('syncZoom', e)
      this.hideTooltip()
    },
    onClick(ev) {
      this.setTooltipVisibility(true)
      this.$emit('chartClicked', ev)
    },
    setTooltipVisibility(alwaysShowContent) {
      const chart = this.$refs[this.refName]
      if (chart) {
        chart.mergeOptions({ tooltip: { alwaysShowContent } })
      }
    },
    hideTooltip() {
      const chart = this.$refs[this.refName]
      this.setTooltipVisibility(false)
      if (chart) {
        chart.dispatchAction({
          type: 'hideTip'
        })
      }
    }
  }
}
</script>
